import React, { useCallback } from 'react'
import { TransformData } from 'react-admin'
import { SaveWithConfirmButton } from './SaveWithConfirmButton'
import { SaveWithConfirmButtonProps } from './type'
import TaskAltIcon from '@mui/icons-material/TaskAlt'

const PublishAndSaveButton: React.FC<SaveWithConfirmButtonProps> = ({
  encType = 'application/json',
  ...props
}) => {
  const transformPublish: TransformData = useCallback((data) => {
    return { ...data, is_published: true }
  }, [])
  return (
    <SaveWithConfirmButton
      label='ra.action.save_and_publish'
      confirmTitle='ra.message.confirmation.save_and_publish.title'
      confirmContent='ra.message.confirmation.save_and_publish.content'
      alwaysEnable
      transform={transformPublish}
      icon={<TaskAltIcon />}
      type='button'
      encType={encType}
      {...props}
    />
  )
}

export default PublishAndSaveButton
